import { convertNonEnglishDigits } from '@digipay/strings';
function validateNationalCode(nationalCode) {
  if (!nationalCode || nationalCode.length !== 10) {
    return false;
  }
  if (parseInt(nationalCode.substr(3, 6), 10) === 0) {
    return false;
  }
  const checksum = +nationalCode.substr(9, 1);
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(nationalCode.substr(i, 1), 10) * (10 - i);
  }
  const result = sum % 11;
  return result <= 1 && result === checksum || result > 1 && checksum === 11 - result;
}
function isValidIBANNumber(input) {
  const iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, '');
  // match and capture (1) the country code, (2) the check digits, and (3) the rest
  const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
  // check syntax and length
  if (!code || iban.length !== 26) {
    return false;
  }
  // rearrange country code and check digits, and convert chars to ints
  const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, letter => {
    return String(letter.charCodeAt(0) - 55);
  });
  // final check
  return mod97(digits) === 1;
}
function mod97(input) {
  let checksum = parseInt(input.slice(0, 2), 10);
  let fragment;
  for (let offset = 2; offset < input.length; offset += 7) {
    fragment = String(checksum) + input.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }
  return checksum;
}
class NgxFormValidator {
  static nationalCodeValidator() {
    return control => {
      if (validateNationalCode(control.value)) {
        return null;
      }
      return {
        invalidNotionalCode: true
      };
    };
  }
  static ibanValidator() {
    return control => {
      if (isValidIBANNumber(control.value.replace('-', '').replace(/\s/ig, ''))) {
        return null;
      }
      return {
        invalidIban: true
      };
    };
  }
  static cellNumberValidator() {
    return control => {
      let value = control.value;
      if (value) {
        value = convertNonEnglishDigits(value);
        const valid = /^09\d{9}$/.test(value);
        return valid ? null : {
          invalidCellNumber: true
        };
      }
      return null;
    };
  }
  birthDateValidator(minAge, maxAge) {
    return control => {
      const now = +new Date();
      const birthTimestamp = +control.value;
      if (birthTimestamp > now) {
        return {
          invalidBirthDate: 'greaterThanNow'
        };
      }
      const age = (now - birthTimestamp) / (1000 * 60 * 60 * 24 * 365.25);
      if (age > maxAge) {
        return {
          invalidBirthDate: 'greaterThanMax'
        };
      }
      if (age < minAge) {
        return {
          invalidBirthDate: 'lessThanMin'
        };
      }
      return null;
    };
  }
  static cardNumberValidator() {
    return control => {
      const regex = /^(^[5|6]\d{15})$/;
      if (regex.test(control.value)) {
        return null;
      }
      return {
        invalidCardNumber: true
      };
    };
  }
}

/*
 * Public API Surface of ngx-form-validator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxFormValidator };
